import { MAIN_QUESTS_GROUP, SIDE_QUESTS_GROUP, appConfig } from "@/constants";
import { RuleId } from "@/domain/gems-game/domain/lib/LatestEarnings";
import { Quest as MainQuest } from "@/domain/gems-game/domain/lib/Quest";
import { EarningType } from "@/domain/gems-game/domain/lib/Quest";
import { QuestTileType } from "@/domain/gems-game/domain/lib/TileType";
import type { Quest, QuestGroup } from "@ui-kit/QuestList";

const ravenQuestBuyQuestTokenRule = new MainQuest({
  id: RuleId.RAVEN_QUEST_BUY_QUEST_TOKEN,
  availableOn: ["Windows"],
  caption: "RavenQuest - Chapter 06",
  customTitle: ["Chapter 06.\n$QUEST is live."],
  customComingSoonTitle: ["Chapter 06.\nComing Soon."],
  logo: new URL(
    "https://cdn.prod.website-files.com/6690d3b7585fd4942634f0fe/675a3caa966e58ea9aa4ea1e_raven-quest-log.webp",
  ),
  backgroundMediaUrl: new URL(
    "https://cdn.prod.website-files.com/6690d3b7585fd4942634f0fe/67d262cf2d033598650fe686_Promotional%3D06.png",
  ),
  gemsAmount: "400",
  analyticsId: "RavenQuestSeriesChapterSix",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OnChain,
  gameId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b",
  discordUrl: new URL("https://discord.gg/6TkYhUx5M4"),
  startDate: new Date("2025-04-01T17:00:00.000Z"),
  endDate: new Date("2025-05-01T17:00:00.000Z"),
  rules: {
    items: [
      'Buy at least 120 $QUEST tokens in one transaction on <a href="https://play.immutable.com/balance/" target="_blank">Immutable</a>.',
    ],
  },
  inGame: false,
  isGemDistributionPending: true,
  gameUrl: new URL("https://play.immutable.com/balance/"),
  ctaText: "Buy Now",
});

const ravenQuestChapterTwoRule = new MainQuest({
  id: RuleId.RAVEN_QUEST_CHAPTER_TWO,
  availableOn: ["Windows"],
  caption: "RavenQuest - Chapter 02",
  customTitle: ["Chapter 02.\nOpen the world of RavenQuest."],
  customComingSoonTitle: ["Chapter 02.\nComing Soon."],
  logo: new URL(
    "https://cdn.prod.website-files.com/6690d3b7585fd4942634f0fe/675a3caa966e58ea9aa4ea1e_raven-quest-log.webp",
  ),
  backgroundMediaUrl: new URL(
    "https://cdn.prod.website-files.com/6690d3b7585fd4942634f0fe/67a34c39f6b7fe76f79f6e8e_Property%201%3D02.webp",
  ),
  gemsAmount: "100",
  analyticsId: "RavenQuestQuest",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OffChain,
  gameId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b",
  discordUrl: new URL("https://discord.gg/6TkYhUx5M4"),
  startDate: new Date("2025-03-14T17:00:00.000Z"),
  endDate: new Date("2025-05-01T17:00:00.000Z"),
  rules: {
    items: [
      "Complete RavenQuest's Tutorial.",
      'Link your Immutable Passport to your <a href="https://ravenquest.io/en/login" target="_blank">RavenQuest account</a> before the end date.',
    ],
  },
  estimateCompletionTime: "30 - 45 mins",
  inGame: true,
  isGemDistributionPending: true,
  gameUrl: new URL("https://ravenquest.io/en"),
});

const ravenQuestChapterThreeRule = new MainQuest({
  id: RuleId.RAVEN_QUEST_CHAPTER_THREE,
  availableOn: ["Windows"],
  caption: "RavenQuest - Chapter 03",
  customTitle: ["Chapter 03.\nRavenQuest at your Fingertips."],
  customComingSoonTitle: ["Chapter 03.\nComing Soon."],
  logo: new URL(
    "https://cdn.prod.website-files.com/6690d3b7585fd4942634f0fe/675a3caa966e58ea9aa4ea1e_raven-quest-log.webp",
  ),
  backgroundMediaUrl: new URL(
    "https://cdn.prod.website-files.com/6690d3b7585fd4942634f0fe/67930d505c977c36eb87dc9e_ravenquest-series-3-background.webp",
  ),
  gemsAmount: "150",
  analyticsId: "RavenQuestSeriesChapterThree",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OffChain,
  gameId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b",
  discordUrl: new URL("https://discord.gg/6TkYhUx5M4"),
  startDate: new Date("2025-03-14T17:00:00.000Z"),
  endDate: new Date("2025-05-01T17:00:00.000Z"),
  rules: {
    items: [
      "Reach Level 10.",
      'Link your Immutable Passport to your <a href="https://ravenquest.io/en/login" target="_blank">RavenQuest account</a> before the end date.',
    ],
  },
  estimateCompletionTime: "3 hours",
  inGame: true,
  isGemDistributionPending: true,
  gameUrl: new URL("https://ravenquest.io/en"),
});

const ravenQuestChapterFourRule = new MainQuest({
  id: RuleId.RAVEN_QUEST_CHAPTER_FOUR,
  availableOn: ["Windows"],
  caption: "RavenQuest - Chapter 04",
  customTitle: ["Chapter 04.\nKill the Astor Demon."],
  customComingSoonTitle: ["Chapter 04.\nComing Soon."],
  logo: new URL(
    "https://cdn.prod.website-files.com/6690d3b7585fd4942634f0fe/675a3caa966e58ea9aa4ea1e_raven-quest-log.webp",
  ),
  backgroundMediaUrl: new URL(
    "https://cdn.prod.website-files.com/6690d3b7585fd4942634f0fe/67930ed3e2fa4a685fd75244_ravenquest-series-4-background.webp",
  ),
  gemsAmount: "200",
  analyticsId: "RavenQuestSeriesChapterFour",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OffChain,
  gameId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b",
  discordUrl: new URL("https://discord.gg/6TkYhUx5M4"),
  startDate: new Date("2025-03-14T17:00:00.000Z"),
  endDate: new Date("2025-05-01T17:00:00.000Z"),
  rules: {
    items: [
      "Kill the Astor Demon.",
      'Link your Immutable Passport to your <a href="https://ravenquest.io/en/login" target="_blank">RavenQuest account</a> before the end date.',
    ],
  },
  estimateCompletionTime: "5 hours",
  inGame: true,
  isGemDistributionPending: true,
  gameUrl: new URL("https://ravenquest.io/en"),
});

const ravenQuestChapterFiveRule = new MainQuest({
  id: RuleId.RAVEN_QUEST_CHAPTER_FIVE,
  availableOn: ["Windows"],
  caption: "RavenQuest - Chapter 05",
  customTitle: ["Chapter 05.\nStorm the Castle."],
  customComingSoonTitle: ["Chapter 05.\nComing Soon."],
  logo: new URL(
    "https://cdn.prod.website-files.com/6690d3b7585fd4942634f0fe/675a3caa966e58ea9aa4ea1e_raven-quest-log.webp",
  ),
  backgroundMediaUrl: new URL(
    "https://cdn.prod.website-files.com/6690d3b7585fd4942634f0fe/67d0e0af43fc37af51aa8e3a_RQ_Promo_Chapter_5v2.webp",
  ),
  gemsAmount: "400",
  analyticsId: "RavenQuestSeriesChapterFive",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OffChain,
  gameId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b",
  discordUrl: new URL("https://discord.gg/6TkYhUx5M4"),
  startDate: new Date("2025-03-14T17:00:00.000Z"),
  endDate: new Date("2025-05-01T17:00:00.000Z"),
  rules: {
    items: [
      "Compete with a Guild in a Guild War.",
      'Link your Immutable Passport to your <a href="https://ravenquest.io/en/login" target="_blank">RavenQuest account</a> before the end date.',
    ],
  },
  estimateCompletionTime: "1-3 Days",
  inGame: true,
  isGemDistributionPending: true,
  gameUrl: new URL("https://ravenquest.io/en"),
});

const ravenQuestBonusRule = new MainQuest({
  id: RuleId.RAVEN_QUEST_BONUS,
  availableOn: ["Windows"],
  customTitle: ["Global Launch Bonus Gems Multiplier."],
  customComingSoonTitle: ["Global Launch Bonus Gems Multiplier.\nComing Soon."],
  caption: "RavenQuest - Bonus",
  subtext: [],
  logo: new URL(
    "https://cdn.prod.website-files.com/6690d3b7585fd4942634f0fe/675a3caa966e58ea9aa4ea1e_raven-quest-log.webp",
  ),
  backgroundMediaUrl: new URL(
    // TODO: add raven quest background media url
    "https://cdn.prod.website-files.com/6690d3b7585fd4942634f0fe/67d0eefa4f27258d224792c4_RQ_Promo_Bonusv2.webp",
  ),
  gemsAmount: "",
  analyticsId: "RavenQuestSeriesBonus",
  type: QuestTileType.MainQuest,
  earningType: EarningType.OffChain,
  description: [],
  isGemDistributionPending: true,
  rules: {
    items: [
      "Acquire one Guild Crest before 1 May.",
      "\nComplete any Chapter in the Global Launch Quest Series, and you will receive 100% Bonus Gems.",
      `\nLink your Immutable Passport to your <a href=\"https://ravenquest.io/en/login\" target=\"_blank\">RavenQuest account</a> before the end date.`,
      `\nExample: If you acquire a Guild Crest and complete 'CHAPTER 2' and 'CHAPTER 3' quests, you'll receive (100 + 150) + ((100 + 150) * 100%) = 500 Gems total. Any fractions of Gems will be rounded up.`,
    ],
  },
  startDate: new Date("2025-03-14T00:00:00Z"),
  endDate: new Date("2025-05-01T00:00:00Z"),
  gameUrl: new URL("https://ravenquest.io/en"),
});

const ravenQuestMainQuestsPlay: Quest[] = [
  {
    type: "custom",
    key: "in-game",
    icon: "PlayGame",
    label: "Open the world",
    caption: "Complete tutorial",
    increase: 100,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-series-chapter-two-completed",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-series-chapter-two",
    ruleModal: ravenQuestChapterTwoRule,
  },
  {
    type: "custom",
    key: "in-game",
    icon: "PlayGame",
    label: "At your fingertips",
    caption: "Reach lvl 10",
    increase: 150,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-series-chapter-three-completed",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-series-chapter-three",
    ruleModal: ravenQuestChapterThreeRule,
  },
  {
    type: "custom",
    key: "in-game",
    icon: "PlayGame",
    label: "Kill the Astor Demon",
    caption: "",
    increase: 200,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-series-chapter-4-completed",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-series-chapter-4",
    ruleModal: ravenQuestChapterFourRule,
  },
  {
    type: "custom",
    key: "in-game",
    icon: "PlayGame",
    label: "Storm the castle",
    caption: "Compete with a guild",
    increase: 400,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-series-chapter-5-completed",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-series-chapter-5",
    ruleModal: ravenQuestChapterFiveRule,
  },
  {
    type: "custom",
    key: "in-game",
    icon: "PlayGame",
    label: "Bonus Multiplier",
    caption: "Purchase on Guild Crest",
    increase: 0,
    badgeIcon: "ImxRewards",
    badgeTemplate: "<icon> Gems",
    eventId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-series-bonus-completed",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-series-bonus",
    ruleModal: ravenQuestBonusRule,
  },
];

const ravenQuestMainQuestsOwn: Quest[] = [
  {
    type: "custom",
    key: "erc20",
    icon: "TreasureChest",
    label: "Buy $QUEST",
    caption: "",
    increase: 400,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId:
      "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-rq-mar-2025-tge-sale-completed",
    ruleId: "rq-mar-2025-tge-sale",
    ruleModal: ravenQuestBuyQuestTokenRule,
  },
];

const ravenQuestQuestsRecurring: Quest[] = [
  {
    type: "link",
    key: "x-post-tweet-validation",
    icon: "X",
    label: "Post on X about playing RavenQuest",
    caption: "Extra Gems daily for sharing on X",
    increase: 10,
    badgeIcon: "Sparkle",
    badgeTemplate: "+<increase> <icon>",
    eventId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-recurring-tweet-completed",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-recurring-tweet",
    startTime: new Date("2025-03-30T02:00:00Z"),
    tweetText: "@RavenQuestGame",
    recurring: true,
    tweetUsername: "@RavenQuestGame",
  },
];

export const ravenQuestQuestsMain: QuestGroup[] = [
  {
    key: "own",
    header: {
      image: "",
      description: "",
      title: "Own game assets",
    },
    totalGemsGranted: 0,
    quests: ravenQuestMainQuestsOwn,
    questGroup: MAIN_QUESTS_GROUP,
  },
  {
    key: "play",
    header: {
      image: "",
      description: "",
      title: "Play the game",
    },
    totalGemsGranted: 0,
    quests: ravenQuestMainQuestsPlay,
    questGroup: MAIN_QUESTS_GROUP,
  },
  {
    key: "recurring",
    progressIcon: "ImxRewards",
    progressTemplate: "Earn extra gems daily",
    hideOnCompletion: false,
    header: {
      image: "",
      description: "",
      title: "Earn Gems daily by posting to socials",
    },
    totalGemsGranted: 10,
    quests: ravenQuestQuestsRecurring,
    questGroup: MAIN_QUESTS_GROUP,
  },
];

const ravenQuestQuestsLvl1: Quest[] = [
  {
    type: "custom",
    key: "follow",
    icon: "Add",
    label: "Follow this game",
    caption: "Get exclusive content",
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "0",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-wishlist",
  },
  {
    type: "video",
    key: "watch",
    icon: "Play",
    label: "Watch Phase 3 trailer",
    caption: "Learn about what's coming up",
    videoMimeType: "video/mp4",
    videoUrl: `${appConfig.PLAY_ASSETS_CDN_BASE_URL}/videos/raven-quest/RavenQuestTrailer.mp4`,
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-trailer-watched",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-trailer",
  },
  {
    type: "link",
    key: "discord-v2",
    icon: "Discord",
    label: "Join Discord channel",
    caption: "Join our massively growing community",
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-discord-followed",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-discord",
    linkUrl: "https://discord.com/invite/bHvAYTpeKV",
  },
  {
    type: "link",
    key: "x-v2",
    icon: "X",
    label: "Follow Raven Quest on X",
    caption: "Don't miss a tweet",
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-twitter-followed",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-twitter",
    linkUrl: "https://x.com/RavenQuestGame",
  },
  {
    type: "custom",
    key: "bonus",
    icon: "ImxRewards",
    label: "Bonus reward",
    caption: "Extra Gems for completing all quests",
    increase: 30,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-onboarding-completed",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-onboarding",
  },
];

const ravenQuestQuestsLvl2VariantA: Quest[] = [
  {
    type: "quiz",
    key: "quiz",
    icon: "PlayGame",
    label: "Which Archetype are you?",
    caption: "From Archery to Wizardry, learn about the A-Z of RavenQuest",
    increase: 15,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-quiz-quest-a-completed",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-quiz-quest-a",
    waitTimeInHrs: 24,
  },
  {
    type: "quiz",
    key: "quiz",
    icon: "ImxRewards",
    label: "Which profession will you have?",
    caption: "Fish, bake, chop, build: what's your thing?",
    increase: 5,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-quiz-quest-b-completed",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-quiz-quest-b",
    waitTimeInHrs: 24,
  },
];

const ravenQuestQuestsLvl3: Quest[] = [
  {
    type: "link",
    key: "website",
    icon: "Sparkle",
    label: "Pre-register for Global Release (before 14th March 8am PST)",
    caption: "",
    linkUrl: "https://ravenquest.io/en/register ",
    increase: 25,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-website-preregister-event",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-website-preregister",
    waitTimeInHrs: 24,
  },
  {
    type: "link",
    key: "website",
    icon: "Document",
    label: "Learn about the RavenQuest and its tried and tested economy",
    caption: "",
    linkUrl: "https://whitepaper.ravenquest.io/economy/quest-tokens-usdquest",
    increase: 25,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-website-whitepaper-event",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-website-whitepaper",
  },
  {
    type: "link",
    key: "website",
    icon: "X",
    label: "Share on X",
    caption: "",
    linkUrl:
      "https://twitter.com/intent/tweet?text=RavenQuest+is+the+%231+Adventure+Game.%0A%0AJust+pre-registered+for+RavenQuest+and+earned+%40Immutable+Gems+in+real-time.%0A%0AMy+%40RavenQuestGame+Free+Launch+Bonuses+are+locked+in+for+March+14th.%0A%0APre-register+now%3A+play.immutable.com/games/ravenquest",
    increase: 25,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-website-post-on-x-event",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-website-post-on-x",
  },
  {
    type: "quiz",
    key: "quiz",
    icon: "Education",
    label: "Test your RavenQuest knowledge",
    caption: "",
    linkUrl: "https://ravenquest.io/en/home",
    increase: 25,
    badgeIcon: "ImxRewards",
    badgeTemplate: "+<increase> <icon> Gems",
    eventId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-website-level3-quiz-event",
    ruleId: "f8dc910f-6fdb-4b16-8d3e-d2586b5d3b2b-website-level3-quiz",
  },
];

export const ravenQuestQuestsVariantA: QuestGroup[] = [
  {
    key: "level-1",
    header: {
      image: "",
      description: "Level 1 Supporter",
      title: "Learn and connect",
    },
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +90 <icon> Gems",
    totalGemsGranted: 90,
    hideOnCompletion: true,
    lockedUntilPrevious: true,
    quests: ravenQuestQuestsLvl1,
    introModal: {
      title: "You are on your way to Level 1",
      description:
        "Thanks for following Raven Quest. Keep showing your support and earn better perks while doing it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z6K6YJbqstJ9-Oza_RQ_level_1.png?auto=format,compress",
    },
    questGroup: SIDE_QUESTS_GROUP,
  },
  {
    key: "level-2",
    header: {
      image: "",
      description: "Level 2 Supporter",
      title: "Contribute to the lore",
    },
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +20 <icon> Gems",
    totalGemsGranted: 20,
    hideOnCompletion: true,
    lockedUntilPrevious: true,
    quests: ravenQuestQuestsLvl2VariantA,
    introModal: {
      title: "Level 2, here you go",
      description:
        "People like you are making Raven Quest a better and bigger game. Let's keep at it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z6K6ZpbqstJ9-Ozb_RQ_level_2.png?auto=format,compress",
    },
    questGroup: SIDE_QUESTS_GROUP,
  },
  {
    key: "level-3",
    header: {
      image: "",
      description: "Level 3 Supporter",
      title: "Delve Deeper",
    },
    nextQuest: {
      url: "/games/norma-in-metaland",
      title: "Thanks for getting involved",
      label: "Want more? Check out Norma in Metaland",
      caption: "Earn additional rewards and support more games",
    },
    progressIcon: "ImxRewards",
    progressTemplate: "Earn +10 <icon> Gems",
    totalGemsGranted: 100,
    hideOnCompletion: false,
    lockedUntilPrevious: true,
    quests: ravenQuestQuestsLvl3,
    introModal: {
      title: "Level 3, here you go",
      description:
        "People like you are making Raven Quest a better and bigger game. Let's keep at it.",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z6K6ZpbqstJ9-Ozb_RQ_level_2.png?auto=format,compress",
    },
    exitModal: {
      title: "That's all folks",
      description:
        "Level 3 Believer achieved. Bigger and better quests are on the horizon!",
      foregroundImage:
        "https://images.prismic.io/imtbl-player-portal/Z6K6aJbqstJ9-Ozc_RQ_level_3.png?auto=format,compress",
    },
    questGroup: SIDE_QUESTS_GROUP,
  },
];
